import styled, { css } from "styled-components";

const sharedButtonStyles = css`
  display: inline-flex;
  align-items: center;
  justify-content: center;

  gap: 6px;

  padding: 10px 18px;
  min-width: 104px;

  border-radius: var(--radius-sm);

  font-size: var(--text-base);
  font-weight: 700;
  font-family: var(--font-sans);

  cursor: pointer;

  transition: all var(--transition-fast);

  flex-shrink: 0;

  outline: none;

  &:disabled {
    opacity: 0.6;
    cursor: not-allowed;
    transform: none;
  }

  &:hover:not(:disabled) {
    transform: translateY(-1px);
  }

  &:active:not(:disabled) {
    transform: translateY(0);
  }
`;

/* ───────────────── PRIMARY ───────────────── */

export const PrimaryButton = styled.button`
  ${sharedButtonStyles};
  border: none;
  background: var(--btn-primary-bg);
  color: var(--btn-primary-text);
  box-shadow: var(--btn-primary-shadow);
  &:hover:not(:disabled) {
    opacity: 0.95;
  }
`;

/* ───────────────── SECONDARY ───────────────── */

export const SecondaryButton = styled.button`
  ${sharedButtonStyles};
  background: var(--btn-secondary-bg);
  color: var(--btn-secondary-text);
  border: 1.5px solid var(--btn-secondary-border);
  &:hover:not(:disabled) {
    background: var(--btn-secondary-bg-hover);
    border-color: var(--btn-secondary-border-hover);
  }
`;

/* ───────────────── TERTIARY ───────────────── */

export const TertiaryButton = styled.button`
  ${sharedButtonStyles};

  background: transparent;

  color: var(--accent);

  border: none;

  padding-left: 8px;
  padding-right: 8px;

  min-width: auto;

  &:hover:not(:disabled) {
    background: var(--accent-3);
  }
`;

/* ───────────────── DANGER ───────────────── */

export const DangerButton = styled.button`
  ${sharedButtonStyles};
  border: none;
  background: var(--btn-danger-bg);
  color: var(--btn-danger-text);
  box-shadow: var(--btn-primary-shadow);
  &:hover:not(:disabled) {
    background: var(--btn-danger-bg-hover);
  }
`;

/* ───────────────── ICON BUTTONS ───────────────── */

export const DeleteButton = ({ children, ...props }) => (
  <DangerButton {...props}>
    <i className="fas fa-trash" aria-hidden="true" />
    {children}
  </DangerButton>
);